import { useState, useMemo, useContext, useEffect, useRef, React } from 'react';
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext.js";
import { convertTo12HourFormat, dateConvert } from '../../../utils/Helper.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import services from '../../../services/services.js';
import { Urls } from '../../../services/Urls.js';
import { callautopopulate } from "../../../services/callautopop";
import { DateObject } from "react-multi-date-picker";
import { useReactToPrint } from 'react-to-print';




export const useGuestlist = () => {
  const tagRef = useRef(null);
  const contentRef = useRef(null);
  const { showSuccess, showInfo, showError } = useContext(ToastContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [inputList, setInputList] = useState([{ phonenumber: "", firstname: "", lastname: "", aadharcard: "", outtime: "", selectedDocument: '', time: '' }]);
  const [vehicleinputList, setvehicleinputList] = useState([{ field_one: "", field_two: "", field_three: "", field_four: "" }]);
  const [inputs, setinputs] = useState({
    role_on_project: '',
    visitorName: "",
    usercode: "",
    status: 'pending',
    time: "",
    remark: "",
    currentTime: dateConvert(new Date(), 'date-time-months'),
    search: '',
    textAreaVisible: false,
    selectedMeet: null,
    selectedDocument: null,
    selectedReason: null,
    selectedVehicleType: null,
    selectedComp: null,
    selectedDocumentNumber: ''
  })
  const input = useRef([]);
  const [loader, setloader] = useState(false)
  const [rowData, setRowData] = useState([]);
  const [dropdownOpt, setdropdownOpt] = useState({
    meet: [],
    visitorreason: [],
    vehicle: [],
    document: [],
    vehicleComp: [],
    status: []

  })
  const statuses = useRef([]);
  const dropdowns = useRef([]);
  const [printData, setPrintData] = useState(null);
  const [showPopUp, setShowPopup] = useState(false);
  const [selectedData, setSelecteddata] = useState(null)

  const [columnDefs] = useState([
    {
      field: 'Print',
      headerName: "Print",
      minWidth: 50,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
      hide: false,
      cellRenderer: function (param) {
        return (
          <div style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon="fa-solid fa-print" onClick={() => getVisitorInfo(param?.data?.visit_id)} />
          </div>
        )
      }
    },
    {
      field: 'visit_date',
      headerName: "Visit Date",
      minWidth: 100,
      width: "15%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
      cellRenderer: function (params) {
        const formatedDate = dateConvert(params?.data?.visit_date)
        return (
          <div>
            {formatedDate}
          </div>
        )
      }
    },
    {
      field: 'visit_time',
      headerName: "Visit Time",
      minWidth: 100,
      width: "15%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'visitor_name',
      headerName: "Visitor Name",
      minWidth: 120,
      width: "30%",
      cellStyle: { textAlign: "left" },
      suppressHeaderMenuButton: true,
      cellRenderer: function (param) {
        return (
          <div>
            {`${param?.data?.visitor_first_name} ${param?.data?.visitor_last_name}`}
            <span style={{ fontWeight: 700 }}>{param?.data?.total !== 0 && ` (${param?.data?.total})`}</span>
          </div>
        )
      }
    },
    {
      field: 'contact_number',
      headerName: "Mobile",
      minWidth: 120,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'visit_meet',
      headerName: "Meet",
      minWidth: 120,
      width: "30%",
      cellStyle: { textAlign: "left" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'visit_reason',
      headerName: "Reason For Meet",
      minWidth: 260,
      width: "30%",
      cellStyle: { textAlign: "left" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'vehical_number',
      headerName: "Vehicle For Meet",
      minWidth: 100,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'document_type_name',
      headerName: "Document",
      minWidth: 100,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
    },
    {
      field: 'status',
      headerName: "Status",
      minWidth: 70,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
      cellRenderer: (params) => {
        const requestStatus = _.findWhere(statuses.current, { request_status_id: Number(params?.data?.request_status_id) })
        return (
          <span>
            {requestStatus?.request_status_name === 'pending' ? <FontAwesomeIcon icon="fa-solid fa-hourglass-start" onClick={() => sethandleAccess((prevState) => ({ ...prevState, showPopUp: true, currentRowData: params.data }))} style={{ color: '#efd54a', cursor: 'pointer' }} /> : requestStatus?.request_status_name === 'approve' ? <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: 'green' }} /> : <FontAwesomeIcon icon="fa-solid fa-thumbs-down" style={{ color: 'red' }} />}
          </span>
        );
      }
    },
    {
      field: '',
      headerName: "Out Time",
      minWidth: 80,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
      hide: false,
      cellRenderer: function (param) {
        return (
          <div style={{ cursor: "pointer" }}>
            {
              param?.data?.visit_out_time ? convertTo12HourFormat(param?.data?.visit_out_time) :
                <FontAwesomeIcon icon="fa-solid fa-person-walking-arrow-loop-left" onClick={() => { setShowPopup(true); setSelecteddata(param?.data) }} />
            }
          </div>
        )
      }
    },
    {
      field: 'edit',
      headerName: "Edit",
      minWidth: 50,
      width: "30%",
      cellStyle: { textAlign: "center" },
      suppressHeaderMenuButton: true,
      cellRenderer: function (param) {
        const requestStatus = _.findWhere(statuses.current, { request_status_id: Number(param?.data?.request_status_id) })

        return (
          <div style={{ cursor: "pointer" }}>
            {requestStatus?.request_status_name === 'pending' ? <FontAwesomeIcon icon='fa fa-edit' onClick={() => handleEditRequest(param.data)} /> : ''}
          </div>
        )
      }
    },

  ]);
  const [hoveredRange, setHoveredRange] = useState([
    new DateObject().subtract(8, 'days'),
    new DateObject().add(0, 'days'),
  ]);
  const [handleAccess, sethandleAccess] = useState({
    showPopUp: false,
    radio: "pending",
    currentRowData: '',
    current_visit_id: 0
  })
  const [filterValues, setfilterValues] = useState({
    selectedMeet: [],
    selectedVisitor: [],
    isChange: false
  })

  useEffect(() => {
    input.current = inputs
  }, [inputs])


  useEffect(() => {
    dropdowns.current = dropdownOpt
  }, [dropdownOpt])

  useEffect(() => {
    callautopopulate("users", "document_type", "vehical_type", "vehical_company", "reasons", "user_activation_status", "visitor_name").then((res) => {
      statuses.current = res?.user_activation_status
      setdropdownOpt((prev) => ({
        ...prev,
        visitorreason: _.filter(res?.reasons, (item) => item?.reason_type_key === "visitor" || item?.reason_type_key === "other"),
        vehicle: res?.vehical_type,
        vehicleComp: res?.vehical_company,
        document: res?.document_type,
        meet: _.sortBy(_.uniq(res?.users, (item) => item.user_code), "user_display_name"),
        visitor: _.sortBy(res?.visitor_name, "visitor_name"),
      }));
      getVisitorList()
    });
  }, [])

  const handleRequest = async (data, outTime) => {
    if (handleAccess.radio === '' && !outTime) {
      showInfo("info", "Please Select Decision")
      return;
    }
    const requestStatus = _.findWhere(statuses.current, { request_status_name: handleAccess.radio })
    const payload = {
      "request_status_id": data ? data?.request_status_id : requestStatus.request_status_id,
      "visit_id": data ? data?.visit_id : handleAccess.currentRowData?.visit_id,
      "visited_user_code": data ? data?.visited_user_code : handleAccess.currentRowData?.visited_user_code,
      "is_visit_out_time": outTime ? outTime : false
    };
    try {
      const res = await services.getInvokeRemote("POST", Urls("UPSERTVISITORREQUEST"), payload)
      if (res.body.data) {
        showSuccess('Success', res.body.message)
        sethandleAccess((prevState) => ({ ...prevState, showPopUp: false, radio: "" }));
        setShowPopup(false);
        setSelecteddata(null)
        getVisitorList();
      }
      else if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
        showError("Error", res.body.errorMessage);
      }

    } catch (error) {
      console.error(error, "Error");
      showError("Error", error?.response?.data?.errorMessage);
    }

  }
    useEffect(() => {
        filterValues?.apiCall && getVisitorList()
    }, [filterValues?.apiCall])


  const getVisitorList = async (range, status) => {
    setloader(true)
    let RowData = []
    const requestStatus = _.findWhere(statuses.current, { request_status_name: status ? status : inputs.status })
    const payload = {
      "visitors_info_ids": !_.isEmpty(filterValues.visitor_name) ? _.pluck(filterValues.visitor_name, "visit_users_info_id").toString() : "",
      "visitor_meet": !_.isEmpty(filterValues.users) ? _.pluck(filterValues.users, "user_code").toString() : "",
      "request_status_id": requestStatus?.request_status_id,
      "from_date": !_.isEmpty(range) ? range[0]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") : hoveredRange[0]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
      "to_date": !_.isEmpty(range) ? range[1]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") : hoveredRange[1]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
    };
    try {
      const res = await services.getInvokeRemote("POST", Urls("GETVISITORLIST"), payload);
      if (!_.isEmpty(res) && res?.body?.data) {
        const getId = Object.keys(res.body.data);
        if (!_.isEmpty(getId)) {
          getId.forEach(item => {
            if (res.body.data.hasOwnProperty(item)) {
              const dataItem = res.body.data[item];
              if (Array.isArray(dataItem) && dataItem.length > 0) {
                dataItem[0]["total"] = dataItem.length - 1;
                dataItem[0]["total_record"] = dataItem
                RowData.push(dataItem[0]);
              }
            }
          });
        }
        setfilterValues((prevState) => ({ ...prevState, isChange: false,apiCall:false}))
        setRowData(RowData);
        setloader(false)

      }
    }
    catch (error) {
      setloader(false)
      console.error(error, "error");
      showError("Error", error?.response?.data?.errorMessage);
    }
  }



  const handleEditRequest = (event) => {
    sethandleAccess((prevState) => ({
      ...prevState,
      current_visit_id: event.visit_id
    }))
    const isWhomToMeet = _.findWhere(dropdowns.current.meet, { user_code: Number(event.visited_user_code) })

    setPopupVisible(true)
    setinputs((prevState) => ({
      ...prevState,
      remark: _.findWhere(dropdowns?.current?.visitorreason, { reason_id: Number(event.reason_id) })?.reason_type_key === 'other' ? event.visit_reason : "",
      selectedMeet: isWhomToMeet,
      textAreaVisible: _.findWhere(dropdowns?.current?.visitorreason, { reason_id: Number(event.reason_id) })?.reason_type_key === 'other' ? true : false,
      currentTime: dateConvert(event?.visit_datetime, 'date-time-months'),
      selectedReason: _.findWhere(dropdowns?.current?.visitorreason, { reason_id: Number(event.reason_id) }),
    }))
    // Function to create an object with common properties
    const createVisitorObject = (eve) => {
      const [hours = "", minutes = ""] = eve?.visit_out_time?.split(":") || [];

      return {
        phonenumber: eve?.contact_number,
        firstname: eve?.visitor_first_name,
        lastname: eve?.visitor_last_name,
        selectedDocument: _.findWhere(dropdowns.current.document, {
          document_type_id: Number(eve?.document_type_id),
        }),
        outtime: (hours && minutes) ? `${hours}:${minutes}` : "",
        time: (hours && minutes) ? `${hours}:${minutes}` : "",
        selectedDocumentNumber: eve?.document_number,
      };
    };


    const createVehicleObject = (eve) => {
      const vehicleNumber = eve?.vehical_number || "";
      const match = vehicleNumber.match(/^([A-Z]{2})(\d{2})([A-Z]{1,2})(\d{3,4})$/i);
      return {
        field_one: match?.[1] || "",
        field_two: match?.[2] || "",
        field_three: match?.[3] || "",
        field_four: match?.[4] || "",
        selectedVehicleType: _.findWhere(dropdowns.current.vehicle, { vehical_type_id: Number(eve.vehical_type_id) }),
        selectedComp: _.findWhere(dropdowns.current.vehicleComp, { vehical_company_id: Number(eve.vehical_company_id) })
      };
    };
    // If event has multiple records, process them and set the input list
    if (event?.total_record?.length >= 1) {
      const visitorData = event?.total_record.map(createVisitorObject);
      const vehicleData = event?.total_record.map(createVehicleObject);
      setInputList(visitorData);
      setvehicleinputList(vehicleData)
    } else {
      const singleVisitor = createVisitorObject(event);
      setInputList([singleVisitor]);
      const singleVehicle = createVisitorObject(event);
      setvehicleinputList([singleVehicle]);
    }
  }

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleAddClick = () => {
    const lastItem = inputList[inputList.length - 1]
    if (Object.values(lastItem).every(value => value === "")) {  // Check if all values in the last object are empty
      showInfo("Info", "Please fill in all basic info fields before adding more.")
    } else {
      setInputList([...inputList, { phonenumber: "", firstname: "", lastname: "", aadharcard: "", outtime: '' }]); //add more Fields
    }
  };



  const handleVehicleAddClick = () => {
    const lastItem = vehicleinputList[vehicleinputList.length - 1]
    if (Object.values(lastItem).every(value => value === "")) {  // Check if all values in the last object are empty
      showInfo("Info", "Please fill in all vehicle info fields before adding more.")
    }
    else {
      setvehicleinputList([...vehicleinputList, { field_one: "", field_two: "", field_three: "", field_four: "" }]);
    }
  };

  const handleVehicleInputChange = (e, index) => {
    const list = [...vehicleinputList];
    const { name, value } = e.target;
    if (e.target.name === "selectedVehicleType" && e.target.value === undefined) {
      Object.keys(list[index]).forEach(key => {
        const currentValue = list[index][key];
        list[index][key] = typeof currentValue === 'object' && currentValue !== null ? {} : '';
      });
    }
    list[index][name] = value;
    setvehicleinputList(list);
  };

  const handleSubmit = async () => {
    let visitor_user_info = [];
    let visitor_vehical_info = [];
    if (_.isEmpty(inputs.selectedMeet)) {
      showInfo("Info", "Please Select Whom To meet");
      return;
    }
    if (!_.isEmpty(inputList)) {
      let atLeastOneDocumentProvided = false;
      for (let i = 0; i < inputList.length; i++) {
        const key = inputList[i];
        let missingFields = [];
        if (!key.firstname) missingFields.push("First Name");
        if (!key.lastname) missingFields.push("Last Name");
        if (!key.phonenumber) missingFields.push("Phone Number");
        // if (!key.time) missingFields.push("Out Time");

        const hasDocType = !!key.selectedDocument?.document_type_id;
        const hasDocNumber = !!key.selectedDocumentNumber;
        if (hasDocType && !hasDocNumber) {
          missingFields.push("Document Number");
        }
        if (hasDocType && hasDocNumber) {
          atLeastOneDocumentProvided = true;
        }
        if (missingFields.length > 0) {
          showInfo("Info", `Please fill ${missingFields.join(", ")} for Visitor Info`);
          return;
        }
        visitor_user_info.push({
          visitor_first_name: key.firstname,
          visitor_last_name: key.lastname,
          visit_out_time: "",
          contact_number: key.phonenumber,
          document_type_id: key.selectedDocument?.document_type_id || 0,
          document_number: key.selectedDocumentNumber || ""
        });
      }
      // if (!atLeastOneDocumentProvided) {
      //   showInfo("Info", "Please provide both Document Type and Document Number for at least one visitor");
      //   return;
      // }
    } else {
      showInfo("Info", "Please provide at least one visitor's basic information");
      return;
    }
    if (_.isEmpty(inputs.selectedReason)) {
      showInfo("Info", "Please Provide Reason To Visit");
      return;
    }
    if (!_.isEmpty(vehicleinputList)) {
      for (let i = 0; i < vehicleinputList.length; i++) {

        const key = vehicleinputList[i];
        const fullNumber = (key?.field_one || '') + (key?.field_two || '') + (key?.field_three || '') + (key?.field_four || '');

        let missingFields = [];
        if (key.selectedVehicleType) {
          if (!key.selectedComp || Object.keys(key.selectedComp).length === 0) missingFields.push("Vehicle Company ");
          if (!key.field_one && !key.field_two && !key.field_three && !key.field_four) missingFields.push("Vehicle Number ");
        }

        const hasDocType = !!key.selectedDocument?.document_type_id;
        const hasDocNumber = !!key.selectedDocumentNumber;
        if (hasDocType && !hasDocNumber) {
          missingFields.push("Document Number");
        }
        if (missingFields.length > 0) {
          showInfo("Info", `Please fill ${missingFields.join(", ")} for Visitor Info`);
          return;
        }
        if (
          !key?.selectedVehicleType?.vehical_type_id &&
          !key?.selectedComp?.vehical_company_id &&
          !fullNumber
        ) continue;
        const vehiclePattern = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{4}$/;
        if (!vehiclePattern.test(fullNumber)) {
          showInfo("Info", ' Please Enter Valid vehicle number format');
          return;
        }
        visitor_vehical_info.push({
          vehical_type_id: key?.selectedVehicleType?.vehical_type_id,
          vehical_company_id: key?.selectedComp?.vehical_company_id,
          vehical_number: fullNumber
        });
      }
    }
    const payload = {
      visit_id: handleAccess?.current_visit_id ? parseInt(handleAccess?.current_visit_id) : 0,
      visited_user_code: inputs?.selectedMeet?.user_code,
      visit_datetime: dateConvert(new Date(), 'iso-string'),
      reason_id: inputs?.selectedReason?.reason_id,
      visit_reason: inputs?.remark,
      visitor_user_info: visitor_user_info,
      visitor_vehical_info: visitor_vehical_info
    };

    try {
      const res = await services.getInvokeRemote("POST", Urls("VISITUPSERT"), payload)
      if (res.body.data) {
        showSuccess('Success', res.body.message)
        setPopupVisible(false);
        handleReset();
        getVisitorList()
      }
      else if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
        showError("Error", res.body.errorMessage);
      }
    } catch (error) {
      console.error(error, "Error");
      showError("Error", error?.response?.data?.errorMessage);
    }

  };

  const handleEvents = () => {
    setfilterValues((prev) => ({
      ...prev, isChange: true
    }));
  }

  useEffect(() => {
    if (_.isObject(printData) && !_.isEmpty(printData)) {
      reactToPrintFn();
    }
  }, [printData]);

  const getVisitorInfo = async (id) => {
    try {
      const payload = {
        "visit_user_info_id": parseInt(id)
      }
      const res = await services.getInvokeRemote("POST", Urls("GETVISITORUSERINFO"), payload);
      if (res?.status === 200 && res?.body?.data?.visitor_user_info_list.length > 0) {
        const visitorInfo = res?.body?.data?.visitor_user_info_list[0]
        const data = [
          { label: "Name", value: visitorInfo?.name },
          { label: "Mobile No", value: visitorInfo?.contact_number },
          { label: "Date", value: dateConvert(visitorInfo?.date) },
          { label: "In Time", value: convertTo12HourFormat(visitorInfo?.in_time || '') },
          { label: "Whom to Meet", value: visitorInfo?.whrom_to_meet },
          { label: "Purpose", value: visitorInfo?.reasons },
          { label: "Person No", value: visitorInfo?.persion_no }
        ]
        setPrintData(data)
      }
    } catch (error) {
      console.error(error, "error");
    }
  }

  // this function handle the guest entry receipt
  const reactToPrintFn = useReactToPrint({
    contentRef,
    documentTitle: "Visitor receipt",
    onAfterPrint: () => {
      setPrintData(null);
    }
  });

  const handleReset = () => {
    setinputs((prevState) => ({
      ...prevState,
      role_on_project: '', visitorName: "", usercode: "",
      time: "", remark: "", currentTime: dateConvert(new Date(), 'date-time-months'),
      search: '', textAreaVisible: false,
      selectedMeet: null, selectedDocument: null,
      selectedReason: null, selectedVehicleType: null,
      selectedComp: null, electedDocumentNumber: ''
    }))
    setPopupVisible(false);
    setvehicleinputList([{ field_one: "", field_two: "", field_three: "", field_four: "" }]);
    setInputList([{ phonenumber: "", firstname: "", lastname: "", aadharcard: "" }]); setinputs((prevState) => ({ ...prevState, time: "", remark: "", currentTime: dateConvert(new Date(), 'date-time-months'), search: '', textAreaVisible: false }))
  }



  return useMemo(() => ({
    filterValues, setfilterValues, handleRequest, columnDefs, rowData, handleAccess, sethandleAccess, getVisitorList, popupVisible, setPopupVisible, loader, inputList, handleInputChange, handleAddClick, handleVehicleAddClick, vehicleinputList, handleVehicleInputChange, inputs, setinputs, handleSubmit, dropdownOpt, hoveredRange, setHoveredRange, tagRef, handleEvents, printData, contentRef, handleReset, showPopUp, setShowPopup, selectedData
  }), [filterValues, setfilterValues, handleRequest, columnDefs, rowData, handleAccess, sethandleAccess, getVisitorList, popupVisible, setPopupVisible, loader, inputList, handleInputChange, handleAddClick, handleVehicleAddClick, vehicleinputList, handleVehicleInputChange, inputs, setinputs, handleSubmit, dropdownOpt, hoveredRange, setHoveredRange, tagRef, handleEvents, printData, contentRef, handleReset, showPopUp, setShowPopup, selectedData
  ]);
}




